import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/constants';
import { sharedStorage } from './cookieStorage';

// Cliente para el frontend. Mirrors session to a cross-domain cookie so
// docs.relo.mx can read it while the portal keeps using localStorage.
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    storage: sharedStorage,
    storageKey: 'sb-relo-auth-token',
    autoRefreshToken: true,
  },
});

// Crear cliente con service role para el worker (solo usar en backend)
export function createServiceClient(serviceRoleKey: string): SupabaseClient {
  return createClient(SUPABASE_URL, serviceRoleKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
    },
  });
}
